import _ from 'underscore';
import { useCallback, useState, useMemo } from 'react';
import {
  getAssetSourceOptions,
} from '../../../model';

export const useAssetSourcesState = ({
  logger,
  i18n,
  handleUsage,
  disabledAssetSources = [],
}) => {
  const [assetSources, setAssetSources] = useState([]);

  const assetSourceOptions = useMemo(() => {
    const options = getAssetSourceOptions(i18n);
    if (!_.isEmpty(disabledAssetSources)) {
      return options.filter(({ key }) => !disabledAssetSources.includes(key));
    }

    return options;
  }, [disabledAssetSources, i18n]);

  const onAssetSourceFilterChange = useCallback((newAssetSources) => {
    if (!_.isEqual(assetSources, newAssetSources)) {
      setAssetSources(newAssetSources);
      logger.logTrace('onAssetSourceFilterChange', { assetSources: (assetSources || []).join(',') });
      if (handleUsage) {
        handleUsage();
      }
    }
  }, [assetSources, handleUsage, logger]);

  return {
    assetSources,
    assetSourceOptions,
    onAssetSourceFilterChange,
  };
};
